<template>
    <v-dialog
        v-model="canvasDialog"
    >
        
    <v-container style="margin-top:0px; padding-top:0px;">
        <v-card outlined>
            <v-toolbar dark color="secondary">
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Trailer Information</v-toolbar-title
                >
                <v-spacer />
                <v-btn icon left 
                        @click="$emit('close')"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <div class="text-center">
                <h2>{{ ltrs.Trailer }}</h2>
            </div>
            <v-container style="marginl-left:10%;">
                <v-row style="    height: 250px;">
                    <v-spacer></v-spacer>
                    <canvas id="canvas" width="700" height="300"></canvas>
                    <v-spacer></v-spacer>
                </v-row>
                <v-row>
                    <v-container>
                        <v-expansion-panels v-model="panel" multiple accordion>
                            <v-expansion-panel
                                v-for="(orders, i) in orders"
                                :key="i"
                            >
                                <v-expansion-panel-header>
                                    #{{ orders.OrderID }} -
                                    {{ orders.LoadNum }} -
                                    {{ orders.LoadNumOrd }}
                                    {{ orders.Station }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-data-table
                                        :headers="headerProducts"
                                        :items="orders.orders"
                                        class="elevation-1"
                                        hide-default-footer
                                        disable-sort
                                    >
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-container>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions v-if="isModalView">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="$emit('close')"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-container>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props:['isModalView','canvasDialog','shift'],
    data: function() {
        return {
            headerProducts: [
                { text: 'Product', value: 'Product', width: '2' },
                { text: 'Ord QTY', value: 'Quantity', width: '2' },
                { text: 'Disp QTY.', value: 'DispatchedQuantity', width: '2' },
                { text: 'OrderID', value: 'OrderID', width: '2' }
            ],
            ltrs: [],
            orders: {},

            panel: [],
            order: {}
        };
    },
    mounted() {
        console.log()
        this.loadTrailer();
        this.loadOrders();
    },
    methods: {
        loadTrailer: function() {
            this.$store.state.isLoading = true;
            axios
                .get('trailer/' + this.shift.Trailer)
                .then(response => {
                    this.ltrs = response.data;
                    console.log(this.ltrs);
                    this.canvas();
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        loadOrders: function() {
            this.$store.state.isLoading = true;
            axios
                .get('order/shift/' + this.shift.ShiftDetail)
                .then(async response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    for (let i = 0; i < this.orders.length; i++) {
                        await this.loadProductsOrder(this.orders[i].OrderID, i);
                        console.log(this.orders);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        loadProductsOrder: function(orderID, index) {
            axios
                .get('order-detail/order/' + orderID)
                .then(response => {
                    this.orders[index].orders = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        canvas() {
            var canvas = document.getElementById('canvas');
            if (canvas.getContext) {
                var ctx = canvas.getContext('2d');
                ctx.font = '12px serif';
                ctx.fillText(this.ltrs.Comp1 + ' Ltrs.', 190, 70);
                ctx.fillText(this.ltrs.Comp2 + ' Ltrs.', 254, 70);
                ctx.fillText(this.ltrs.Comp3 + ' Ltrs.', 317, 70);
                ctx.fillText(this.ltrs.Comp4 + ' Ltrs.', 382, 70);
                ctx.fillText(this.ltrs.Comp5 + ' Ltrs.', 444, 70);
                ctx.fillText(this.ltrs.Comp6 + ' Ltrs.', 506, 70);
            }
        },
        //show all orders in panels
        view: function() {
            this.viewOrders = !this.viewOrders;
            if (this.viewOrders) {
                this.all();
            } else {
                this.none();
            }
        },
        all: function() {
            this.panel = [...Array(this.orders.length).keys()].map((k, i) => i);
        },
        // Reset the panel
        none: function() {
            this.panel = [];
        }
    }
};
</script>
<style>
#canvas {
    background-image: url('../../../assets/trailer.png');
}
</style>
x|
